import { TaxSlab } from './types';

export const newRegimeSlabs: TaxSlab[] = [
  { slab: 'Up to 4 lakh', rate: 'Nil' },
  { slab: '4 lakh to 8 lakh', rate: '5%' },
  { slab: '8 lakh to 12 lakh', rate: '10%' },
  { slab: '12 lakh to 16 lakh', rate: '15%' },
  { slab: '16 lakh to 20 lakh', rate: '20%' },
  { slab: '20 lakh to 24 lakh', rate: '25%' },
  { slab: 'Above 24 lakh', rate: '30%' },
];

export const oldRegimeSlabs: TaxSlab[] = [
  { slab: 'Up to 2.5 lakh', rate: 'Nil' },
  { slab: '2.5 lakh - 5 lakh', rate: '5%' },
  { slab: '5 lakh - 10 lakh', rate: '20%' },
  { slab: 'Above 10 lakh', rate: '30%' },
];
